// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"48":"f3fcd97d","134":"cf3b886a","225":"5140471c","405":"34d22f57","429":"dd9963da","532":"1de1975c","642":"fb8aae7d","701":"ac243c71","821":"1fad5b5a","916":"2304637f"}[chunkId] + ".js";
};